import styled from 'styled-components'

export const Toggle = styled.label`
	align-items: center;
	display: flex;
	gap: 1rem;
	position: relative;

	${(props) => props.theme.typography.bodyM}
	user-select: none;
`

export const ToggleButton = styled.div`
	background-color: ${(props) => props.theme.colors.ui3};
	border-radius: 0.75rem;
	cursor: pointer;
	height: 1.5rem;
	inset: 0 auto auto 0;
	position: absolute;
	transition: background-color 400ms;
	width: 3rem;

	&:after {
		content: '';
		height: 1rem;
		inset: 0.25rem auto auto 0.25rem;
		position: absolute;
		width: 1rem;

		background-color: ${(props) => props.theme.colors.backgroundPrimary};
		transition: transform 400ms;
		border-radius: 50%;
	}
`

export const ToggleCheckbox = styled.input.attrs(() => ({
	type: 'checkbox',
}))`
	appearance: none;
	height: 1.5rem;
	width: 3rem;
	z-index: 1;

	&:checked {
		+ ${ToggleButton} {
			background-color: ${(props) => props.theme.colors.ui1};

			&:after {
				transform: translateX(1.5rem);
			}
		}
	}
`
